import { useEffect } from 'react';
import trophy from '../assets/trophy.png'
import '../Css/Score.css'
import { useDispatch } from 'react-redux';
// import { RiseLoader } from "react-spinners"
import { resetUserState } from '../Redux/UserSlice';

function Score() {
    const dispatch = useDispatch();
    // const interviewId = useSelector((state) => state.User.interviewId);
    // const [loading, setLoading] = useState(false);
    // const [score, setScore] = useState(null);
    // const fetchInterviewResult = async () => {
    //     setLoading(true);
    //     let res = await fetch(`${process.env.REACT_APP_API_URL}/v2/complete_interview/${interviewId}`, {
    //         method: "POST"
    //     });
    //     // let res = await fetch(`${process.env.REACT_APP_API_URL}/v2/complete_interview/68567032097d9f86b8f8a4fa`, {
    //     //     method: "POST"
    //     // });
    //     res = await res.json();
    //     console.log(res);
    //     if (res.status === "success") {
    //         setScore(res.evaluation.overall_score);
    //         localStorage.removeItem('persist:root');
    //     }
    //     setLoading(false);
    // }

    // const override = {
    //     display: "block",
    //     margin: "0 auto",
    //     borderColor: "red",
    //     zIndex: "5"
    // };

    useEffect(() => {
        dispatch(resetUserState());
    }, []);

    return (
        <>
            {/* {loading &&
                <div className="overlay" >
                    <RiseLoader
                        loading={loading}
                        color='#F49507'
                        size={24}
                        cssOverride={override}
                    />
                </div>
            } */}
            <div className="interview_link_body_container">
                <div className="page_header">
                    <p>INTERVIEW COMPLETION</p>
                </div>
                <div className="interview_score_body_container">
                    <div className="trophylogo">
                        <img src={trophy} alt="" />
                    </div>
                    <div className="interview_score_section1">
                        Congratulations! You’ve successfully completed the interview.
                    </div>
                    {/* <div className="interview_score_section2">
                        <p>Your Score is</p>
                        <label><span>{score}</span> out of 100</label>
                    </div> */}
                    <div className="interview_score_section3">
                        <p>Thank you for your time and patience. Your responses have been recorded, and our team will get back to you shortly.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Score
